import React, { useState } from 'react';
import { Button, Box, Typography, Card, CardContent, Alert, InputLabel, Stack, OutlinedInput } from '@mui/material';
import axios from 'axios';
import { COLORS } from '../theme/colors';
const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);

        // Basic validation
        if (!formData.name || !formData.email || !formData.message) {
            setError('Name, Email, and Message fields are required.');
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError('Please enter a valid email address.');
            return;
        }


        try {
            const response = await axios.post('https://alphatnc-5138977eb927.herokuapp.com/send-email', formData);

            if (response.status === 200) {
                setSuccess(true);
                if (typeof window.gtag === 'function') {
                    window.gtag('event', 'contact_form_submit');
                }
                setFormData({
                    name: '',
                    company: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            }
        } catch (error) {
            setError('Failed to send email. Please try again later.');
        }
    };

    const handleReset = () => {
        setFormData({
            name: '',
            company: '',
            email: '',
            phone: '',
            message: ''
        });
        setError('');
        setSuccess(false);
    };

    return (
        <Box display="flex" justifyContent="center" width="100%" sx={{ mt: { xs: 6, sm: 10, md: 15 }, mb: { xs: 6, sm: 10, md: 15 }, px: { xs: 1.25, sm: 0 } }}>
            <Card sx={{ width: '100%', maxWidth: 800, boxShadow: 3, borderRadius: 2, bgcolor: COLORS.overlay }}>
                <CardContent>
                    <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2}>
                        <Typography variant="h4" color="primary" gutterBottom>
                            Contact Us
                        </Typography>
                        <Typography variant="body1" color="white" >
                            Fill out the form to get in touch with us!
                        </Typography>
                    </Box>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    {success && <Alert severity="success" sx={{ mb: 2 }}>Email sent successfully!</Alert>}
                    <Box component="form" onSubmit={handleSubmit} >
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Stack width={'100%'}>
                                    <InputLabel htmlFor="contact-name" sx={{ color: 'white' }}>Name*</InputLabel>
                                    <OutlinedInput
                                        id="contact-name"
                                        autoComplete="name"
                                        name="name"
                                        placeholder='First name'
                                        value={formData.name}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                        sx={{ bgcolor: COLORS.overlay, color: 'white' }}
                                    />
                                </Stack>
                                <Stack width={'100%'}>
                                    <InputLabel htmlFor="contact-company" sx={{ color: 'white' }}>Company</InputLabel>
                                    <OutlinedInput
                                        id="contact-company"
                                        autoComplete="organization"
                                        name="company"
                                        placeholder='Company name'
                                        value={formData.company}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        sx={{ bgcolor: COLORS.overlay, color: 'white' }}
                                    />
                                </Stack>
                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Stack width={'100%'}>
                                    <InputLabel htmlFor="contact-email" sx={{ color: 'white' }}>Email*</InputLabel>
                                    <OutlinedInput
                                        id="contact-email"
                                        autoComplete="email"
                                        name="email"
                                        type="email"
                                        placeholder='Email address'
                                        value={formData.email}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                        sx={{ bgcolor: COLORS.overlay, color: 'white' }}
                                    />
                                </Stack>
                                <Stack width={'100%'}>
                                    <InputLabel htmlFor="contact-phone" sx={{ color: 'white' }}>Phone number</InputLabel>
                                    <OutlinedInput
                                        id="contact-phone"
                                        autoComplete="tel"
                                        name="phone"
                                        type="tel"
                                        value={formData.phone}
                                        placeholder='Phone Number'
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        sx={{ bgcolor: COLORS.overlay, color: 'white' }}
                                    />
                                </Stack>
                            </Stack>
                            <Stack width={'100%'}>
                                <InputLabel htmlFor="contact-message" sx={{ color: 'white' }} >Message*</InputLabel>
                                <OutlinedInput
                                    id="contact-message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    variant="outlined"
                                    required
                                    rows={3}
                                    multiline
                                    fullWidth
                                    sx={{ bgcolor: COLORS.overlay, color: 'white' }}
                                />
                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Button
                                    type="submit"
                                    className="Action-button"
                                    variant='contained'
                                    fullWidth
                                    sx={{
                                        borderRadius: '8px',
                                        border: `2px solid ${COLORS.brandOrange}`,
                                        fontSize: '1.1rem',
                                        background: COLORS.brandOrange,
                                        boxShadow: `0`,
                                        '&:hover': {
                                            background: '#ee652b',
                                            borderColor: '#ee652b',
                                        },
                                        '&:focus-visible': {
                                            outline: '2px solid #ee652b',
                                            outlineOffset: '2px',
                                        },
                                    }}>
                                    Submit
                                </Button>
                                <Button onClick={handleReset} variant="outlined" color="secondary" fullWidth sx={{
                                    backgroundColor: 'transparent', color: 'white', borderColor: 'divider', '&:hover': {
                                        backgroundColor: COLORS.overlay
                                    }
                                }}>
                                    Reset
                                </Button>
                            </Stack>
                        </Stack>
                    </Box>
                </CardContent>
            </Card>
        </Box >
    );
};

export default ContactForm;
